import { NewLogin } from "@/components/auth/NewLogin";
import { Colors } from "@/enums/Colors";
import { Spinner } from "@/external/ensolvers-core-frontend-mui-v5/components/Common/Spinner";
import { useIsNewLoginEnabled } from "@/hooks/queries/auth/useAuthQueries";
import { ComponentType } from "react";

/**
 * Decides what `/login` renders (LAZ-2464).
 *
 * This is the load-bearing seam of the migration. The redirect is a property of *arriving at the
 * route*, not of any particular link, so it covers every caller at once — in-product navigations
 * and equally arrivals from outside the product, where there is no call site to patch: emails,
 * bookmarks, search results, a typed address.
 *
 * A spinner is shown until the flag resolves rather than falling back to the legacy screen: with
 * the flag on, rendering the old login for a beat and then replacing it reads as a flicker, and a
 * person may well have started typing into it by then.
 */
export interface LoginRouteGateProps {
  /** The legacy login screen, injected so this file does not depend on the route's own imports. */
  legacy: ComponentType;
}

export const LoginRouteGate = ({ legacy: Legacy }: LoginRouteGateProps) => {
  const { enabled, isReady } = useIsNewLoginEnabled();

  if (!isReady) {
    return <Spinner sx={{ color: Colors.LAZO_PURPLE }} />;
  }

  return enabled ? <NewLogin /> : <Legacy />;
};
